export function formatMoney(amount: number, currency: string) {
  const code = (currency || "").trim().toUpperCase();
  const safe = /^[A-Z]{3}$/.test(code) ? code : "AED";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: safe,
    maximumFractionDigits: Number.isInteger(amount) ? 0 : 2,
  }).format(amount);
}

export function formatLongDate(iso: string) {
  if (!iso) return "";
  const date = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString("en-IN", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function formatReleaseDate(iso: string | null | undefined) {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}

export function formatShortDate(iso: string) {
  if (!iso) return "";
  const date = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
  });
}

export function reviewLabel(ratingOutOfFive: number) {
  const score = Math.round(ratingOutOfFive * 20) / 10;
  const label =
    score >= 9.2
      ? "Superb"
      : score >= 8.6
        ? "Excellent"
        : score >= 8
          ? "Very good"
          : "Good";
  return { score: score.toFixed(1), label };
}
